import styled from 'styled-components';

export const BalancesItemIcon = styled.img`
  flex: 0 0 auto;
  width: 19px;
  height: 19px;
  margin-right: 4px;
`;
